export default __webpack_public_path__ + "static/media/GEO.42a468aa.svg";